import type { PortalSection } from '../lib/roles';

export function SectionStub({ section }: { section: PortalSection }) {
  return (
    <div className="content-stub">
      <h1>{section.label}</h1>
      <p>This section is planned but not yet built (see ROADMAP.md §17.2).</p>
    </div>
  );
}
